import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      position: 'relative',
      flexDirection: 'column-reverse',
      marginBottom: LARGE_MARGIN,
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    infoWrapper: {
      [theme.breakpoints.up('md')]: {
        marginBottom: MIDDLE_MARGIN,
        width: '50%',
        paddingRight: MIDDLE_MARGIN,
      },
    },
    title: {
      marginBottom: SMALL_MARGIN,
    },
    description: {
      marginBottom: MIDDLE_MARGIN,
    },
    videoBlockWrap: {
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        width: '50%',
        marginBottom: 0,
      },
    },
    videoWrap: {
      width: '100%',
      overflow: 'hidden',
      position: 'relative',
      paddingBottom: '56%',
      borderRadius: 5,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        paddingBottom: '56%',
      },
    },
    videoBlock: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
    },
    video: {
      width: '100%',
      height: '100%',
    },
  }),
);

export default useStyles;
